/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', () => {
	initializeScrollToElements();
	handleBlackFridayRedirect();

	document.addEventListener('product:added', async (event) => {
		await calculateFreeDiscounts(event);
	});

	document.addEventListener('product:quantity:increased', async (event) => {
		await calculateFreeDiscounts(event);
	});
});

async function calculateFreeDiscounts(event) {
	const activeDiscounts = window.store.activeDiscounts[0];
	const eligibleProducts = activeDiscounts?.eligibleProducts;
	const giftProducts = activeDiscounts?.giftProducts;
	const variantAdded = event.detail.variant;
	const minimumMainProductPrice = activeDiscounts?.minimumMainProductPrice;
	const minimumMainProductPriceType = activeDiscounts?.minimumMainProductPriceType;
	let currentEligibleProduct = undefined;

	if (!variantAdded) return;

	if (minimumMainProductPriceType === 'per_product') {
		if (minimumMainProductPrice && parseInt(minimumMainProductPrice) > 0) {
			currentEligibleProduct = eligibleProducts?.find((product) => product.variants.some((variant) => variant.id === parseInt(variantAdded.id) && variant.price / 100 >= parseInt(minimumMainProductPrice)));
		} else {
			currentEligibleProduct = eligibleProducts?.find((product) => product.variants.some((variant) => variant.id === parseInt(variantAdded.id)));
		}

		// Check if the added product is eligible for the discount
		if (!currentEligibleProduct) return;

		if (currentEligibleProduct) {
			// Check if the gift product is available
			const giftProductAvailable = giftProducts?.find((product) => product.variants.find((variant) => variant.available));

			// Check if the gift product is available
			if (giftProductAvailable) {
				// Add the gift product to the cart
				await addGiftProductToCart(giftProductAvailable);
			}
		}
	} else if (minimumMainProductPriceType === 'per_order') {
		const giftProductAvailable = giftProducts?.find((product) => product.variants.find((variant) => variant.available));
		const cartData = await fetch(`${window.routes.cartUrl}.js`, {
			credentials: 'same-origin',
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'XMLHttpRequest',
			},
		}).then((response) => response.json());

		if (!giftProductAvailable || giftProductAvailable.variants.find((variant) => variant.id === parseInt(variantAdded.id)) || !cartData) {
			return;
		}

		const currentItemsInCart = cartData.items;
		const eligibleProductsInCart = currentItemsInCart.filter((item) => eligibleProducts.some((product) => product.variants.find((variant) => variant.id === parseInt(item.id))));
		const sumOfLinePricesFromEligibleProductsInCart = eligibleProductsInCart.reduce((acc, item) => acc + (item.line_price / 100), 0);
		const giftCardAlreadyInCart = cartData.items.find((item) => item.variant_id === giftProductAvailable.variants.find((variant) => variant.available).id);

		if (sumOfLinePricesFromEligibleProductsInCart >= parseInt(minimumMainProductPrice) && !giftCardAlreadyInCart) {
			await addGiftProductToCart(giftProductAvailable);
		}
	}
}

async function addGiftProductToCart(giftProduct) {
	await fetch(`${window.routes.cartAddUrl}.js`, {
		body: JSON.stringify({
			items: [
				{
					id: giftProduct.variants.find((variant) => variant.available).id,
					quantity: 1,
				},
			],
		}),
		credentials: 'same-origin',
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
		},
	}).then((response) => {
		document.dispatchEvent(new CustomEvent('theme:loading:end'));

		if (response.ok) {
			document.documentElement.dispatchEvent(
				new CustomEvent('cart:refresh', {
					bubbles: true,
				})
			);
		} else {
			response.json().then((content) => {
				console.log('Error adding gift product to cart:', content['description']);
			});
		}
	});
}

function initializeScrollToElements() {
	const scrollToElements = document.querySelectorAll('[data-scroll-to-element]');
	if (scrollToElements.length) {
		scrollToElements.forEach((element) => {
			element.addEventListener('click', () => handleScrollToElement(element));
			element.removeEventListener('click', () => handleScrollToElement(element));
		});
	}
}

function handleScrollToElement(element) {
	const targetElement = document.querySelector(element.dataset.scrollToElement);

	if (targetElement) {
		targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
	}
}

// Function to create a unique identifier
function generateUniqueID() {
	return Date.now().toString() + Math.random().toString(36).substring(2);
}

// Function to handle Black Friday redirection
function handleBlackFridayRedirect() {
	const currentURL = new URL(window.location.href);
	const urlToRedirect = window.routes?.blackFridayRedirectUrl;
	const isRedirectEnabled = window.theme?.blackFridayEnabled;

	// Check if this tab has already been redirected and if the user is on the homepage
	if (!sessionStorage.getItem('blackFridayTabId') && currentURL.pathname === '/' && isRedirectEnabled && urlToRedirect) {
		// Set a unique tab identifier to mark this tab as redirected
		sessionStorage.setItem('blackFridayTabId', generateUniqueID());

		// Redirect the user to the Black Friday page
		window.location.replace(`${currentURL.origin}${urlToRedirect}`);
	}
}
